export const numericCheckLayout: string[][] = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["back-space", "0", "check"],
];
export const numericClearLayout: string[][] = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["clear", "0", "back-space"],
];
export const lowercaseLayout: string[][] = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "back-space"],
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ç"],
  ["shift", "z", "x", "c", "v", "b", "n", "m", ",", ".", "check"],
  [" "],
];
export const upercaseLayout: string[][] = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "back-space"],
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ç"],
  ["shift", "Z", "X", "C", "V", "B", "N", "M", ",", ".", "check"],
  [" "],
];
export const completeLayout: string[][] = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "back-space"],
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M", ",", ".", "/"],
  [" "],
];
export const emailLayout: string[][] = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "-", "_"],
  ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "back-space"],
  ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
  ["z", "x", "c", "v", "b", "n", "m", "@", ".", ".com", ".br"],
];
const passwordKeys = [
  [
    ["1 - 2", "3 - 4"],
    ["5 - 6", "7 - 8"],
    ["back-space", "9 - 0", "check"],
  ],
  [
    ["8 - 7", "1 - 6"],
    ["2 - 5", "3 - 4"],
    ["back-space", "9 - 0", "check"],
  ],
  [
    ["8 - 4", "9 - 1"],
    ["6 - 5", "7 - 3"],
    ["back-space", "0 - 2", "check"],
  ],
  [
    ["8 - 0", "1 - 6"],
    ["4 - 9", "3 - 5"],
    ["back-space", "2 - 7", "check"],
  ],
  [
    ["1 - 3", "2 - 6"],
    ["7 - 4", "5 - 9"],
    ["back-space", "0 - 8", "check"],
  ],
  [
    ["7 - 8", "0 - 5"],
    ["3 - 1", "2 - 4"],
    ["back-space", "6 - 9", "check"],
  ],
  [
    ["5 - 1", "4 - 3"],
    ["2 - 9", "6 - 8"],
    ["back-space", "7 - 0", "check"],
  ],
  [
    ["4 - 5", "1 - 8"],
    ["3 - 9", "2 - 6"],
    ["back-space", "0 - 7", "check"],
  ],
  [
    ["3 - 9", "0 - 7"],
    ["4 - 6", "2 - 5"],
    ["back-space", "1 - 8", "check"],
  ],
  [
    ["5 - 8", "9 - 3"],
    ["0 - 1", "4 - 7"],
    ["back-space", "2 - 6", "check"],
  ],
];
const randomInt = () => {
  return Math.floor(passwordKeys.length * Math.random());
};

export const getStrongPasswordLayout = (): string[][] => {
  return passwordKeys[randomInt()];
};